<template>
    <div class="wrapper">
        <div class="error" v-show="error_show">
            <i class="icon icon-exclaim"></i>
            <p class="error-text" v-text="error_txt"></p>
        </div>
        <div class="element-wrapper">
            <div class="element-title">
                <h3>IFSC Code</h3>                
            </div>
            <div class="element-content">
                <input type="text" v-model="obj.ifscCode" placeholder="Please Input" @focus="focus($event,'bankCode')" @blur="blurs($event,'bankCode')" @input="isfcInput($event)">
            </div>
        </div>
        <div class="element-wrapper">
            <div class="element-title">
                <h3>Bank Account  No.</h3>                    
            </div>
            <div class="element-content">
                <input type="tel" @focus="focus($event,'cardNo')" @blur="blurs($event,'cardNo')" @input="textInput($event, 'cardNo')" id='bank_account' v-model="obj.bank_account" placeholder="Please Input">
            </div>
        </div>
        <div class="element-wrapper">
            <div class="element-title">
                    <h3>Confirm Account No.</h3>                    
                </div>
            <div class="element-content">
                <input type="tel" @focus="focus($event,'confirmCardNo')" @blur="blurs($event,'confirmCardNo')" @input="textInput($event, 'confirmCardNo')" v-model="obj.bank_account_confirm" id="account_confirm" placeholder="Please Input">
            </div>
        </div>
        <div class="forget">
            <router-link :to="`/bank/ifsc?pid=${$route.query.pid}`">Forget your IFSC ?</router-link>
        </div>
        <div class="btn-container">
            <a class="btn-submit" @click.prevent="submit">Apply Now</a>
        </div>
    
    </div>
</template>
<script>
import { reactive,ref,getCurrentInstance,onMounted,onBeforeMount, onBeforeUnmount, } from 'vue'
import { useRouter } from 'vue-router'
import { bindCard, bury} from '@api/index'
import { useLoading } from 'vue-loading-overlay'
import { useStore } from 'vuex'
import { v4 as uuidv4} from 'uuid'
export default {
    setup () {
        const states = reactive([])
        const error_show = ref(false)
        const error_txt = ref('')
        const router = useRouter()
        const route = router.currentRoute
        const $loader = useLoading()
        const clicked = ref(false)
        const proxy = getCurrentInstance().proxy
        const store = useStore()
        const obj = reactive({
            ifscCode: route.value.query.ifsc_code || '',
            bank_account:'',
            bank_account_confirm:'',
        })
        const requestId = ref(uuidv4())
        const inputCount = ref(0)
        const isfcInput = () => {
            inputCount.value = inputCount.value + 1
        }
        const textInput = (e) => {
            const v = e.target.value
            if(/\D+/.test(v)) {
                e.target.value = e.target.value.substring(0, e.target.value.length - 1 )
            } else if (v.length >= 20) {
                e.target.value = e.target.value.substring(0, e.target.value.length - 1 )
            } 
            // obj[name] = e.target.value
            inputCount.value = inputCount.value + 1
        }
        onBeforeMount(()=>{
            store.dispatch('bury', {eventId:"bank_page_page_view"})
            store.dispatch("clearBuryCache", [])
        })
        onBeforeUnmount(()=>{
            store.dispatch('bury', {eventId:"bank_page_exit_page_tech"})
            store.dispatch("clearBuryCache", [])
        })
        const validate = () => {
            let res = true
            if(!obj.ifscCode.length) {
                error_show.value = true
                error_txt.value = 'Please input Ifsc Code'
                res = false
            } else if (!obj.bank_account.length) {
                error_show.value = true
                error_txt.value = 'Please input Bank Account'
                res = false
            } else if (!obj.bank_account_confirm.length) {
                error_show.value = true
                error_txt.value = 'Please input Confirm Account'
                res = false
            } else if (obj.bank_account != obj.bank_account_confirm) {
                error_show.value = true
                error_txt.value = 'Please Confirm Account'
                res = false
            } 
            return res
        }
        onMounted(()=>{
            bury({
                    "projectName":"creditChar", 
                    "pageName":"addBank",
                    "behavior":"enter",
                    "value":"enter",
                    "eventTime":""
            })
        })
        const submit = () => {
            store.dispatch("bury",{"event_id":"bank_page_enter_button_click"})
            if(validate() && !clicked.value) {
                clicked.value = true
                const loader = $loader.show({
                    container:null
                })                
                bindCard({
                    bankCode: obj.ifscCode,
                    cardNo:obj.bank_account,
                    productId: route.value.query.pid,
                    "clientId": 0,
                    "confirmCardNo": obj.bank_account,
                }).then((res)=>{
                    clicked.value = false
                    loader.hide()
                    if(res.code == 0) {
                        store.dispatch("bury",{"event_id":"bank_page_enter_button_click_success"})
                        store.dispatch("uploadBury")
                        router.push({
                            path:'/bank',
                            query:{
                                pid: route.value.query.pid
                            }
                        })
                    } else {
                        proxy.$toast.show(res.msg)
                        store.dispatch("bury",{"event_id":"bank_page_enter_button_click_success", message:res.msg})
                    }
                })
            }
        }
        const focus = (e,name) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["bank_page"][name]['focus'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: 0                   
                })            
            } catch(e) {
                console.log(e)
            } 
        }
        const blurs = (e,name) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["bank_page"][name]['complete'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: inputCount.value                  
                })            
                inputCount.value = 0 
                requestId.value = uuidv4()
            } catch(e) {
                console.log(e)
            } 
            
        }
        return {
            focus,
            blurs,
            isfcInput,
            states,
            obj,
            textInput,
            submit,
            error_show,
            error_txt
        }
    }
}
</script>
<style lang="less" scoped>
@import "assets/less/icon.less";
.wrapper{
    padding: 50px 65px;
    
    .error{      
      height:30px;  
      font-size: 30px;
      display: flex;
      .icon{
        flex:0 0 auto;
        margin-right: 15px;
      }
      .error-text{
        flex:1 0 auto;
        color:#C5340B;
      }
    }
}
.forget{
    width: 536px;
    height: 96px;
    background: #FF6611;
    border-radius: 12px;
    text-align: center;
    color:#FF6611;
    font-size: 32px;
    line-height: 96px;
    margin:60px auto;
}
.btn-container{
        position:fixed;
        bottom:50px;
        left:0;
        width: 100%;
        height: 96px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#FF6611;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
        }
    }
.element-wrapper{
    padding-bottom: 30px;
    border-bottom: 2px solid #EFEEF1;
    position: relative;
    margin-bottom: 30px;
    &.is_error{
        border-bottom:  2px solid #C5340B;       
    }
    .element-title{
        color:#73698F;
        font-size: 26px;  
        overflow: hidden;
        padding:15px 0;      
        h3{
            float:left;
        }
        .icon-exclaim{
            float:left;
            margin-left: 20px;
        }
        .icon-arrow-down{
            float:right
        }
    }
    .element-content{
        margin-top: 30px;
        color:#000;
        font-size: 36px;
        height:40px;
        line-height: 40px;
        input{
            display:block;
            width: 100%;
            font-size: 32px;
            border:none;
            &::placeholder{
                color:#D0CDDA;
            }
        }
    }
}    
</style>